import React from 'react'
import Popup from '../Popup/Popup'
import TrailerVideoWrapper from './TrailerVideoWrapper'
import FskWrapper from '../MovieInformation/FskWrapper'


const TrailerPopup = ({trailerURL, prerollUrl, fsk, displayPopup, addClassToPopup, openPopup, closePopup, setNeturalColorsForFsk, translation}) => (
    <Popup addClassToBackdrop="trailer-popup" displayPopup={displayPopup} addClassToPopup={addClassToPopup} onClosePopup={closePopup} translation={translation}>
        <TrailerVideoWrapper 
            fsk={fsk} 
            trailerURL={trailerURL} 
            prerollUrl={prerollUrl} 
            disableTrailer={openPopup} 
            translation={translation}
        />
        <FskWrapper labelFsk={true} fsk={fsk}/>
    </Popup>
)

export default TrailerPopup